const baseURL = `${process.env.VUE_APP_SERVER_URL}/Terceiros`;

function postTerceiros(url, vinculo, data) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/${url}`,
      query: {
        vinculo
      },
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(error.message);
    });
}

function buildRevalidacaoPayload({ autenticacao, idPessoa, tpRevalidacao }) {
  return {
    autenticacao,
    idPessoa,
    tipoRevalidacao: tpRevalidacao
  };
}

function buildNomeadoPayload({
  nome,
  cpf,
  rne,
  rg,
  emissorRg,
  dtEmissaoRg,
  dtNascimento,
  idLocalNascimento,
  ufLocalNascimento,
  nomeLocalNascimento,
  sexo,
  nomeMae,
  idGrauRelacionamento,
  dsGrauRelacionamento,
  complementoGrauRelacionamento,
  nrCelular,
  smsCelular,
  nrFixo,
  tpFixo,
  tpEmail,
  email,
  avisoEmail,
  tpRevalidacao
}) {
  return {
    nome,
    cpf,
    estrangeiro: !rg,
    documento: { numero: rg || rne, emissor: emissorRg, strDataEmissao: dtEmissaoRg },
    strDataNascimento: dtNascimento,
    localNascimento: {
      id: idLocalNascimento,
      uf: ufLocalNascimento,
      nome: nomeLocalNascimento
    },
    sexo,
    nomeMae,
    GrauRelacionamento: {
      id: idGrauRelacionamento,
      descricao: dsGrauRelacionamento,
      complemento: complementoGrauRelacionamento
    },
    telefoneCelular: {
      formatado: nrCelular,
      tipo: "CEL",
      receberSms: smsCelular
    },
    telefoneFixo: {
      formatado: nrFixo,
      tipo: tpFixo,
      receberSms: false
    },
    email: {
      tipo: tpEmail,
      endereco: email,
      receberAviso: avisoEmail
    },
    tipoRevalidacao: tpRevalidacao
  };
}

export async function AdicionarBeneficiario({ vinculo, autenticacao, idPessoa, tpRevalidacao }) {
  return postTerceiros(
    "AdicionarBeneficiario",
    vinculo,
    buildRevalidacaoPayload({ autenticacao, idPessoa, tpRevalidacao })
  );
}

export async function AdicionarNomeado({
  vinculo,
  autenticacao,
  nome,
  cpf,
  rne,
  rg,
  emissorRg,
  dtEmissaoRg,
  dtNascimento,
  idLocalNascimento,
  ufLocalNascimento,
  nomeLocalNascimento,
  sexo,
  nomeMae,
  idGrauRelacionamento,
  dsGrauRelacionamento,
  complementoGrauRelacionamento,
  nrCelular,
  smsCelular,
  nrFixo,
  tpFixo,
  tpEmail,
  email,
  avisoEmail,
  tpRevalidacao
}) {
  const data = buildNomeadoPayload({
    nome,
    cpf,
    rne,
    rg,
    emissorRg,
    dtEmissaoRg,
    dtNascimento,
    idLocalNascimento,
    ufLocalNascimento,
    nomeLocalNascimento,
    sexo,
    nomeMae,
    idGrauRelacionamento,
    dsGrauRelacionamento,
    complementoGrauRelacionamento,
    nrCelular,
    smsCelular,
    nrFixo,
    tpFixo,
    tpEmail,
    email,
    avisoEmail,
    tpRevalidacao
  });

  return postTerceiros("AdicionarNomeado", vinculo, {
    autenticacao,
    ...data
  });
}

export async function EditarNomeado({
  vinculo,
  idPessoa,
  nome,
  cpf,
  rne,
  rg,
  emissorRg,
  dtEmissaoRg,
  dtNascimento,
  idLocalNascimento,
  ufLocalNascimento,
  nomeLocalNascimento,
  sexo,
  nomeMae,
  idGrauRelacionamento,
  dsGrauRelacionamento,
  complementoGrauRelacionamento,
  nrCelular,
  smsCelular,
  nrFixo,
  tpFixo,
  tpEmail,
  email,
  avisoEmail,
  tpRevalidacao
}) {
  const data = buildNomeadoPayload({
    nome,
    cpf,
    rne,
    rg,
    emissorRg,
    dtEmissaoRg,
    dtNascimento,
    idLocalNascimento,
    ufLocalNascimento,
    nomeLocalNascimento,
    sexo,
    nomeMae,
    idGrauRelacionamento,
    dsGrauRelacionamento,
    complementoGrauRelacionamento,
    nrCelular,
    smsCelular,
    nrFixo,
    tpFixo,
    tpEmail,
    email,
    avisoEmail,
    tpRevalidacao
  });

  return postTerceiros("EditarNomeado", vinculo, {
    idPessoa,
    ...data
  });
}

export async function ObterCadastroNomeado({ vinculo, id }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/ObterCadastroNomeado`,
      query: {
        vinculo
      },
      data: {
        id
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(error.message);
    });
}

export async function ObterMunicipios({ vinculo, uf }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterMunicipios`,
      query: {
        vinculo,
        uf
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(error.message);
    });
}

export async function ObterNomeados({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterNomeados`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(error.message);
    });
}

export async function ObterParametros({ vinculo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterParametros`,
      query: {
        vinculo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(error.message);
    });
}

export async function Prorrogar({ vinculo, autenticacao, idPessoa, tpRevalidacao }) {
  return postTerceiros("Prorrogar", vinculo, buildRevalidacaoPayload({ autenticacao, idPessoa, tpRevalidacao }));
}

export async function Reativar({ vinculo, autenticacao, idPessoa, tpRevalidacao }) {
  return postTerceiros("Reativar", vinculo, buildRevalidacaoPayload({ autenticacao, idPessoa, tpRevalidacao }));
}

export async function Revogar({ vinculo, autenticacao, idPessoa }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/Revogar`,
      query: {
        vinculo
      },
      data: {
        autenticacao,
        idPessoa
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      throw new Error(error.message);
    });
}
